import { FileApiServices } from "../../../../services/api/FileServiceClient";
import { getFileUrl } from "../../../../services/FilesService";
import store from "../../../../state/configureStore";


export const uploadingTheFile = async (
	file,
	conversationId,
	fileName,
	fileScope = null,
	scopeId
) => {

	const isOnline = store.getState().user.isOnline;

	try {
		if (isOnline) {
			await FileApiServices.uploadLargeFile({
				file,
				conversationId,
				scopeId: scopeId || conversationId,
				fileName,
				fileScope,
			});
		} else {
			// Uncomment and implement queueFileUpload when offline support is ready
			// await queueFileUpload({
			//   file,
			//   conversationId,
			//   scopeId: conversationId,
			//   fileName,
			//   fileScope,
			// });
		}
		const fileUrl = await getFileUrl(conversationId, fileName);
		return fileUrl;
	} catch (error) {
		console.error("Error on upload", error);
		throw error;
	}
}
